export default {
  title: 'Managment Categories',
  btnAdd:'Add category',
  loading:'loading ...',
  empty:'list is empty',



}
